import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { HashRouter } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop.tsx";
import { ParallaxProvider } from "react-scroll-parallax";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ProductProvider from "./context/useCurrentProduct.tsx";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HashRouter>
      <QueryClientProvider client={queryClient}>
        <ParallaxProvider>
          <ScrollToTop />
          <ProductProvider>
            <App />
          </ProductProvider>
        </ParallaxProvider>
      </QueryClientProvider>
    </HashRouter>
  </StrictMode>,
);
